module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "TheConfirmation__mask",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.hide()
      }
    }
  }, [_c('div', {
    staticClass: "TheConfirmation"
  }, [_c('div', {
    staticClass: "TheConfirmation__body"
  }, [_vm._v("\n            " + _vm._s(_vm.translate(_vm.title)) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "TheConfirmation__bottom"
  }, [_c('BaseButtonFlat', {
    attrs: {
      "label": 'COMMON__CANCEL'
    },
    on: {
      "click": function($event) {
        _vm.hide()
      }
    }
  }), _vm._v(" "), _c('BaseButton', {
    attrs: {
      "label": 'COMMON__YES',
      "accent": true
    },
    on: {
      "click": function($event) {
        _vm.ok($event.target)
      }
    }
  })], 1)])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10fcfa1a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/TheConfirmation.vue
// module id = 652
// module chunks = 1